module.exports = __webpack_public_path__ + "a018aebfc181c3abdbeacfffefab5c5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/commons/red.png
// module id = 1341
// module chunks = 0